import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';

const ROWS_PER_PAGE = 15;

export const useGetOnsiteInterviewList = ({ postingId, professionalId }, options) => {
  const [filters, setFilters] = useState({
    status: '',
    orderBy: '',
    orderDirection: '',
    page: 1,
  });

  const {
    data: response,
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: ['GET_ONSITE_INTERVIEW_LIST', postingId, filters],
    queryFn: async () =>
      PermanentJobsService.getOnsiteInterviewList({
        postingId,
        page: filters.page,
        limit: ROWS_PER_PAGE,
        orderBy: filters.orderBy,
        orderDirection: filters.orderDirection,
        status: filters.status,
        professionalId,
      }),
    retry: false,
    enabled: !!postingId,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
  });

  const handleFilterChange = (key, value) => {
    setFilters((prev) => {
      if (prev[key] === value) {
        return prev;
      }
      return {
        ...prev,
        [key]: value,
        page: 1,
      };
    });
  };

  const handlePageChange = (page) => {
    setFilters((prev) => ({
      ...prev,
      page,
    }));
  };

  return {
    data: response?.data || [],
    filters,
    isLoading: isLoading || isFetching,
    total: response?.total || 0,
    totalPages: Math.ceil((response?.total || 0) / ROWS_PER_PAGE),
    isError,
    error,
    handleFilterChange,
    handlePageChange,
  };
};
